import { render, staticRenderFns } from "./FormSupplier.vue?vue&type=template&id=672822c1&"
import script from "./FormSupplier.vue?vue&type=script&lang=js&"
export * from "./FormSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports